import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const MenuAndContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 17%;
  min-width: 220px;
  background-color: ${props => (props.darkMode ? '#212121' : 'white')};
`

export const MenuListContainer = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  list-style-type: none;
`

export const MenuItem = styled.li`
  width: 100%;
`
export const LinkEl = styled(Link)`
  text-decoration: none;
`

export const MenuItemBtn = styled.button`
  width: 100%;
  padding: 8px 35px 8px 20px;
  font-size: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  outline: none;
  cursor: pointer;
  border-width: 0;
  color: ${props => (props.darkMode ? '#f4f4f4' : '#212121')};
  background-color: transparent;
`
export const SelectedBtn = styled(MenuItemBtn)`
  color: ${props => (props.darkMode ? '#f1f1f1' : '#212121')};
  background-color: ${props => (props.darkMode ? '#383838' : '#f1f5f9')};
`

export const Icon = styled.div`
  font-size: 18px;
  color: ${props => (props.darkMode ? '#f4f4f4' : '#212121')};
`

export const SelectedIcon = styled(Icon)`
  color: #ff0000;
`

export const MenuOptionContent = styled.p`
  margin-left: 24px;
`

export const ContactContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`

export const ContactHeading = styled.p`
  font-weight: 500;
  color: ${props => (props.darkMode ? '#f4f4f4' : '#00306e')};
`

export const ContactMediaContainer = styled.div`
  display: flex; ;
`

export const ContactImg = styled.img`
  width: 32px;
  margin-right: 16px;
`

export const GreetingsContent = styled.p`
  color: ${props => (props.darkMode ? '#f4f4f4' : '#212121')};
  font-size: 14px;
`
